const $ = jQuery.noConflict();

'use strict';
const AccordionPropertySingle = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.accorcion();
	},

	accorcion: function() {
		$('.js-acc-property-details').on('click', '.js-acc-property-details-btn', function(e) {
			e.preventDefault();
			const $content = $(this).next('.js-acc-property-details-content').not(':animated');
			$content.slideToggle(function() {
				if ($content.is(':visible')) {
					$(this).prev().addClass('active');
				} else {
					$(this).prev().removeClass('active');
				}
			});
		});
	},
};

export default AccordionPropertySingle;
